export { PageStaticsFormComponent as PageStaticsDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/statics-form/index.tsx